/* global RdcTracking */

const DEFAULT_VALUE = 'unknown';

export const trackLead = function(pd) {
  const lead_attributes = pd.lead_attributes || {};
  const commonProps = commonPropsForLead(pd);
  const isBdp = pd.is_building;

  const opts = {
    propertyStatus: pd.property_type,
    source: pd.source,
    flags: pd.flags,
    leadType: getLeadType(lead_attributes.lead_type, isBdp),
    showContactALender: lead_attributes.show_contact_a_lender,
    isLcmEnabled: lead_attributes.is_lcm_enabled,
    leadFlow: (pd.is_mal ? 'mal' : null),
    placementData: pd.placementData, //object that takes: pageType, pageSection, and pageAction, OR the entire constructed placement string
    leadAdditions: pd.leadAdditions,
    isBdp,
  }
  RdcTracking.trackLead(commonProps, opts);
};

const commonPropsForLead = function(pd) {
  return ({
    propertyStatus: pd.property_status || pd.property_type || DEFAULT_VALUE,
    productType: pd.product_type || pd.productType || pd.producttype || DEFAULT_VALUE, // comes from adobeDTM, not propertyDetails, assigned from the function call
    state: pd.state_code || DEFAULT_VALUE,
    zip: pd.postal_code || DEFAULT_VALUE,
    city: pd.city || DEFAULT_VALUE,
    listingPrice: pd.price || DEFAULT_VALUE,
    creditScore: getCreditScore(pd.leadCreditScore) || DEFAULT_VALUE,
    leadGuid: pd.leadGuid,
    listingId: pd.listing_id || DEFAULT_VALUE,
    moveInDate: pd.moveInDate,
    leadAgentSelectionCount: pd.leadAgentSelectionCount,
    roleType: pd.roleType,
    dsProducts: getDataScienceProducts(pd.property_status, pd.quick_to_sell_days),
    actlv: pd.leadValue,
    adjv: pd.initialLeadValue,
    lcmOptIn: pd.lcmOptIn,
    linkName: (pd.is_mal ? pd.linkName : null),
    listingActivity: pd.statusTags ? pd.statusTags : DEFAULT_VALUE,
    listingBeds: pd.beds,
    listingBaths: pd.baths,
    listingSqFt: pd.sqft,
    propertyType: (pd.type || pd.prop_type) || DEFAULT_VALUE,
    rentalDataSource: pd.rentalDataSource,
    placementData: pd.placementData
  });
};

const getDataScienceProducts = function(prop_status, qts) {
  if (prop_status === 'for_sale' && typeof(qts) !== 'undefined'){
    return 'hot-buy';
  }
};

const getLeadType = function(leadType, isBdp) {
  return (isBdp ? 'co_broke' : leadType);
};

const getCreditScore = function(creditScore) {
  if (creditScore && creditScore.length) {
    return creditScore;
  }
};


export const trackLeadText = function({property, leadPlacement}) {
  const {propertyStatus, listing} = property;
  const { leadDelivery } =  listing;
  const opts = {
    textLeads: `web:leads:text:${propertyStatus}:${leadDelivery}`,
    linkName: `web:leads:text:${propertyStatus}:${leadDelivery}`,
    leadPlacement: `${leadPlacement}`,
  }
  RdcTracking.trackEvent('forSaleCobrokeTextLead', opts);
}



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/leads.js